import { TutorialStep } from 'src/replicant/tutorial/tutorial.ruleset';
import { showTutorial } from '../tutorial.util';
import { TutorialEvent } from '../TutorialController';
import OrdinaryTutorial from './OrdinaryTutorial';

export class Match3Tutorial extends OrdinaryTutorial {
  public readonly step: TutorialStep = 'match3';

  public async handleEvent(event: TutorialEvent): Promise<boolean> {
    if (event !== 'match3Started') return false;

    await showTutorial('match3', {
      $stepIndex: 9,
      $stepName: 'match3_start',
    });

    return true;
  }
}
